//  check if pur-facet-filter is defined or not
if (!customElements.get('pur-facet-filter')) {
    // get facet filter settings which are defined in the snippets/facet-filter-config.liquid file
    const facetFilterSettings = window.FACET_FILTER.settings;
    // create a new template element
    let facetFilterTemplate = document.createElement("template");

    // set the template content
    facetFilterTemplate.innerHTML = `
        <div class="container customtabcollection advanced_search_tabs">
            <div class="filter-car-home">
                <ul class="nav nav-pills filtertabnav">
                    <li>
                        <a data-toggle="pill" href="#cartab1" class="searchtab carfiltertab active">
                        <div class="filter-car">
                            <div class="filter-car-image">
                                ${facetFilterSettings.car_filter_icon_img ? `<img class="display-car-image" src="${facetFilterSettings.car_filter_icon_img}"> ` : ''}
                            </div>
                            <div class="filter-car-title">
                                ${facetFilterSettings.car_filter_title ? `<h3 class="display-car-title">${facetFilterSettings.car_filter_title}</h3>` : ''}
                            </div>
                        </div>
                        </a>
                    </li>
                    <li class="home-filter-tab">
                        <a data-toggle="pill" href="#hometab2" class="searchtab homeairtab">
                        <div class="filter-home">
                            <div class="tag-coming-soon">Coming Soon</div>
                            <div class="filter-home-image">
                                ${facetFilterSettings.home_filter_icon_img ? `<img class="display-car-image" src="${facetFilterSettings.home_filter_icon_img}"> ` : ''}
                            </div>
                            <div class="filter-home-title">
                                ${facetFilterSettings.home_filter_title ? `<h3 class="display-car-title">${facetFilterSettings.home_filter_title}</h3>` : ''}
                            </div>
                        </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content searchtabcontent">
            <div id="cartab1" class="tab-pane filtercontent filtercarcontent active" >    
                <div class="search-filters-page"> 
                    <div class="search-filters-page-inner">
                        <div class="search-filters-wrap">
                            <form id="fixed-filter-form" class="fixed-filter-form advanceform" action="javascript:void(0)">
                                <input type="hidden" name="baseVehicleId" id="baseVehicleId" value="N/A" />
                                <div class="filter-form-inputs" data-car-filter>
                                    <select data-facet="year" name="searchYear" id="termYear" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Year">
                                        <option class="disabled" disabled="" selected="" value="">Vehicle Year</option>
                                    </select>
                                    <select data-facet="make" name="searchMake" id="termMake" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Make">
                                        <option class="disabled" disabled="" selected="" value="">Vehicle Make</option>
                                    </select>
                                    <select data-facet="model" name="searchModel" id="termModel" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Model">
                                        <option class="disabled" disabled="" selected="" value="">Vehicle Model</option>
                                    </select>
                                    <div id="extra-facet-filters"></div>
                                </div>
                                <div class="filter-error-message" data-car-filter-error-msg></div>
                                <input style="display:none;" type="button" class="btn btn--primary btn-filter-result" value="Search" data-car-filter-btn/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="hometab2" class="hm-filter-wrap tab-pane filtercontent homecarcontent">
                <div class="search-filters-page"> 
                    <div class="search-filters-page-inner">
                        <div class="search-filters-wrap">
                            <form  action="javascript:void(0)" method="get"  id="fixed-home-filter" class="fixed-home-filter fixed-filter-form advanceform">
                                <div class="filter-form-inputs">
                                    <select data-facet="width" name="searchWidth" id="searchWidth" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Depth">
                                        <option value="" selected="" value="">Filter Width</option>
                                    </select>
                                    <select data-facet="height" name="searchHeight" id="searchHeight" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Depth">
                                        <option value="" selected="" value="">Filter Length</option>
                                    </select>
                                    <select data-facet="depth" name="searchDepth" id="searchDepth" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Depth">
                                        <option value="" selected="" value="">Filter Depth</option>
                                    </select>
                                </div>
                                <div class="filter-error-message" data-home-filter-error-msg></div>
                                <input style="display:none;" type="button" class="btn btn--primary btn-hm-filter-result" value="Search" data-home-filter-btn/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    `;
    // define API URLs
    const autoCompleteAPI = window?.FACET_FILTER?.settings?.autoCompleteAPIURL || 'https://api.pureflowair.com/api/v5/common/autocompleteData';
    const API_FACET_BASE_URL = autoCompleteAPI;//"https://api.pureflowair.com/api/v3/common/autocompleteData";
    const API_PRODUCT_BASE_URL = "https://api.pureflowair.com/api/v3/getProducts";

    const FACETS_ATTRIBUTES = {
        "engineBaseId": "engine",
        "engine":"engineBaseId",
        "AspirationID":"Aspiration" ,
        "BedLengthID":"Bed Length" ,
        "BedTypeID":"Bed Type" ,
        "BodyNumDoorsID":"Body Num Doors" ,
        "BodyTypeID":"Body Type" ,
        "BrakeABSID":"Brake ABS" ,
        "BrakeSystemID":"Brake System" ,
        "CylinderHeadTypeID":"Cylinder Head Type" ,
        "DriveTypeID":"Drive Type" ,
        "EngineDesignationID":"Engine Designation" ,
        "EngineMfrID":"Engine Mfr" ,
        "EngineVersionID":"Engine Version" ,
        "EngineVINID":"Engine VIN" ,
        "FrontBrakeTypeID":"Front Brake Type" ,
        "FrontSpringTypeID":"Front Spring Type" ,
        "FuelDeliverySubTypeID":"Fuel Delivery SubType" ,
        "FuelDeliveryTypeID":"Fuel Delivery Type" ,
        "FuelSystemControlTypeID":"Fuel System Control Type" ,
        "FuelSystemDesignID":"Fuel System Design" ,
        "FuelTypeID":"Fuel Type" ,
        "IgnitionSystemTypeID":"Ignition System Type" ,
        "MfrBodyCodeID":"Mfr Body Code" ,
        "PowerOutputID":"Power Output" ,
        "RearBrakeTypeID":"Rear Brake Type" ,
        "RearSpringTypeID":"Rear Spring Type" ,
        "RegionID":"Region" ,
        "SteeringTypeID":"Steering Type" ,
        "SteeringSystemID":"Steering System" ,
        "SubModelID":"Sub Model" ,
        "TransElecControlledID":"Trans Elec Controlled" ,
        "TransmissionControlTypeID":"Transmission Control Type" ,
        "TransmissionMfrID":"Transmission Mfr" ,
        "TransmissionMfrCodeID":"Transmission Mfr Code" ,
        "TransmissionNumSpeedsID":"Transmission Num Speeds" ,
        "TransmissionTypeID":"Transmission Type" ,
        "ValvesPerEngineID":"Valves Per Engine" ,
        "WheelBaseID":"Wheel Base" 
    };

    const YMM_ATTRIBUTES = {
        "year":"termYear",
        "make":"termMake",
        "model":"termModel"
    }

    // define facet filter class which extends the HTMLElement class
    class PurFacetFilter extends HTMLElement {

        // define the constructor for the class
        constructor() {
            super();
            this.settings = window.FACET_FILTER.settings; // get the settings from the global variable
            this.appendChild(facetFilterTemplate.content.cloneNode(true)); // append the template to the element
            this.searchQuery = ""; // define the search query
            this.homeSearchQuery = ""; // define the home search query
            this.isHomeFilterApply = false; // define the home filter apply flag
            this.isFilterApply = false; // define the filter apply flag
            // define home filter tags
            this.homeFilterTags = [
                '12x12x1',
                '12x24x1',
                '14x14x1',
                '14x20x1',
                '14x30x1',
                '16x20x1',
                '16x24x1',
                '16x25x1',
                '16x25x2',
                '18x18x1',
                '18x20x1',
                '20x20x1',
                '20x24x1',
                '20x25x1',
                '20x20x2',
                '20x25x2',
                '20x20x4',
                '20x25x4',
                '20x20x5',
                '20x25x5',
                '24x24x1'
            ];
            this.hasForceReload = (new URLSearchParams(location.search)).get('force_reload') === 'yes';
            this.selectedFilter = {}; // define the selected filter
            this.selectedHomeFilter = {}; // define the selected home filter
            this.staticDropdown = ["year", "make", "model", "engine", "region"]; // define the static dropdown with default values
        }

        // define the connectedCallback function this will trigger when the element is attached to the DOM
        connectedCallback() {
            this.preSelectedTab(); // preselect the tab
            this.fetchFacetData({},false); // fetch the facet data
            this.fetchHomeData("","","",false); // fetch the home data
            this.setupEventListeners(); // setup the event listeners for YMM filter
            this.getSelectedFilterFromURL(); // get the selected filter from the URL
            this.preFillFacetDropdown(); // prefill the facet filter dropdown
            this.preFillHomeDropdown(); // prefill the home filter dropdown
        }

        // define then disconnectCallback function this will trigger when the element is detached from the DOM
        disconnectedCallback() {
        }

        // this will use to prepare select2 data for the facet filter dropdown
        _matcher(params, data){
            
                // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                let modifiedData = $.extend({}, data, true);
                
                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            }

            // Return `null` if the term should not be displayed
            return null;
        }

        // pre-selected value for the facet dropdown if the URL has a filter
        async preFillFacetDropdown() {
            let _selectedFilter = this.selectedFilter;

            if(Object.keys(_selectedFilter).length === 0) return;

            let _dropDownFillCall = [];
            let __this = this;
            Object.keys(_selectedFilter).forEach(function(key){
                switch (key) {
                    case "baseVehicleId":
                        let baseVehicleIdSelector = __this.querySelector("#baseVehicleId");
                        baseVehicleIdSelector.value = _selectedFilter[key];    
                        break;
                    case "termYear":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear
                        },false, true));
                        break;
                    case "termMake":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake
                        },false, true));
                        break;
                    case "termModel":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel
                        },false, true));
                        break;
                    case "engineBaseId":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel,
                            engineBaseId: _selectedFilter?.engineBaseId,
                            baseVehicleId: _selectedFilter?.baseVehicleId
                        },false, true));
                        break;
                    default: 
                        let _tmpObj = {};
                        _tmpObj[key] = _selectedFilter[key];
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel,
                            engineBaseId: _selectedFilter?.engineBaseId,
                            baseVehicleId: _selectedFilter?.baseVehicleId,
                            ..._tmpObj
                        },false, true));
                        break;
                }
            });
            
            let _fillAllDropdownRes = await Promise.all(_dropDownFillCall).then(response => {
                return response;
            });
            
            if(_fillAllDropdownRes.length > 0){
                Object.keys(_selectedFilter).forEach(function(key){
                    if(key === "baseVehicleId"){
                        let baseVehicleIdSelector = __this.querySelector("#baseVehicleId");
                        baseVehicleIdSelector.value = _selectedFilter[key];
                    }else{
                        __this.querySelector(`#${key}`).value = _selectedFilter[key],
                        $(`#${key}`).attr("data-select2-id") && $(`#${key}`).val(_selectedFilter[key]).trigger("change")
                    }
                });
            }
        }

        // pre-selected tab for the tab if the URL has a tab type defined as hash value
        preSelectedTab() {
            let __this = this;
            let _tab  = window.location.hash || "#cartab1";
            if(_tab === "#cartb1"){
                this.querySelector('[href="#cartab1"]') ? (
                    this.querySelector('[href="#cartab1"]').classList.add("active"),
                    this.querySelector('#cartab1') ? (__this.querySelector('#cartab1').classList.add("active", "show") ) : ""
                ) : undefined;
                this.querySelector('[href="#hometab2"]') ? (
                    this.querySelector('[href="#hometab2"]').classList.remove("active"),
                    this.querySelector('#hometab2') ? (
                        this.querySelector('#hometab2').classList.remove("active", "show") ) : ""
                ) : undefined;
            }else if(_tab === "#hometab2"){
                this.querySelector('[href="#cartab1"]') ? (
                    this.querySelector('[href="#cartab1"]').classList.remove("active"),
                    this.querySelector('#cartab1') ? (__this.querySelector('#cartab1').classList.remove("active", "show") ) : ""
                ) : undefined;
                this.querySelector('[href="#hometab2"]') ? (
                    this.querySelector('[href="#hometab2"]').classList.add("active"),
                    this.querySelector('#hometab2') ? (
                        this.querySelector('#hometab2').classList.add("active", "show") ) : ""
                ) : undefined;
            }
        }

        // get the selected tab from the URL
        getCurrentActiveTab(){
            let _tab  = window.location.hash || "#cartab1";
            return _tab.includes("#hometab2") ? "#hometab2" : "#cartab1";
        }

        // prefill the home dropdown with the selected filter values
        preFillHomeDropdown () {
            let _selectedHomeFilter = this.selectedHomeFilter;
            if(Object.keys(_selectedHomeFilter).length === 0) return;

            if(_selectedHomeFilter.hasOwnProperty("termWidth")){
                this.fetchHomeData("","","",false);
                this.fetchHomeData(_selectedHomeFilter.termWidth,"","",false);
            }
            if(_selectedHomeFilter.hasOwnProperty("termHeight")){
                this.fetchHomeData(_selectedHomeFilter.termWidth,_selectedHomeFilter.termHeight,"",false);
            }
            if(_selectedHomeFilter.hasOwnProperty("termDepth")){
                this.fetchHomeData(_selectedHomeFilter.termWidth,_selectedHomeFilter.termHeight,_selectedHomeFilter.termDepth,false);
            }
            
            _selectedHomeFilter.hasOwnProperty("termWidth") ? (
                this.querySelector("#searchWidth").value = _selectedHomeFilter.termWidth,
                $(`#searchWidth`).attr("data-select2-id") && $(`#searchWidth`).val(_selectedHomeFilter.termWidth).trigger("change")
            ) : undefined;
            _selectedHomeFilter.hasOwnProperty("termHeight") ? (
                this.querySelector("#searchHeight").value = _selectedHomeFilter.termHeight,
                $(`#searchHeight`).attr("data-select2-id") && $(`#searchHeight`).val(_selectedHomeFilter.termHeight).trigger("change")
            ) : undefined;
            _selectedHomeFilter.hasOwnProperty("termDepth") ? (
                this.querySelector("#searchDepth").value = _selectedHomeFilter.termDepth,
                $(`#searchDepth`).attr("data-select2-id") && $(`#searchDepth`).val(_selectedHomeFilter.termDepth).trigger("change")
            ) : undefined;
        }

        // get selected filter values from the URL
        getSelectedFilterFromURL() {
            let urlParams = new URLSearchParams(decodeURIComponent(window.location.href));
            console.log("urlParams", urlParams)
            let advanceFilter = urlParams.get("filter") || "";
            let _filterData = (advanceFilter !== "" && advanceFilter.split("=")) || [];
            let _selectedFilter = {};
            if (_filterData.length > 0){
                let _filterValues = _filterData[1].split("|");
                if(_filterValues.length > 0){
                    for (let index = 0; index < _filterValues.length; index++) {
                        let _filterValue = _filterValues[index];
                        let _filterKeyValue = _filterValue.split(":");
                        _selectedFilter[_filterKeyValue[0]] = _filterKeyValue[1];        
                    }
                }
            }
            let _selectedHomeFilter = {};
            if(window.location.search.includes("?q") && window.location.pathname === '/search'){
                let _homeSearch = window.location.search.replace('?q=','').split(',');
                if(_homeSearch[0] === "hvac"){
                    _selectedHomeFilter = {
                        termWidth:Number(_homeSearch[1].match(/\d+/g).join()),
                        termHeight:Number(_homeSearch[2].match(/\d+/g).join()),
                        termDepth:Number(_homeSearch[3].match(/\d+/g).join())
                    }
                }
            }
            this.selectedFilter = _selectedFilter;
            this.selectedHomeFilter = _selectedHomeFilter;
        }

        // spinner for the search results
        facetWaitSpinner(isLoading = false){
            let _facetFormContainer = this.querySelector('#fixed-filter-form');
            if(_facetFormContainer){
                isLoading === true ? (
                    _facetFormContainer.classList.add("disabled-field")
                ) : (
                    _facetFormContainer.classList.remove("disabled-field")
                )
                
            }
        }

        clearAllFilters(clearFields) {
            let _filterQuery = {};
            let facetYmmFilters = document.querySelectorAll(".facet__select_ymm") && Array.prototype.slice.call(document.querySelectorAll(".facet__select_ymm")) || [];
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");
            clearFields = clearFields || ["termMake", "termModel", "engineBaseId"];
            if(facetYmmFilters.length > 0){
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    let _facetFilterId = facetYmmFilter.getAttribute("id");
                    if(facetYmmFilter.value !== "" && clearFields.includes(_facetFilterId)){
                        facetYmmFilter.value = "";
                        if(_facetFilterId === "engineBaseId" && baseVehicleIdSelector){
                            baseVehicleIdSelector.value = "";
                        }
                    }
                }
            }
            return _filterQuery;
        }

        buildFilterQuery(){
            let _filterQuery = {};
            let facetYmmFilters = document.querySelectorAll(".facet__select_ymm") && Array.prototype.slice.call(document.querySelectorAll(".facet__select_ymm")) || [];
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");
            if(facetYmmFilters.length > 0){
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    if(facetYmmFilter.value !== ""){
                        _filterQuery[facetYmmFilter.getAttribute("id")] = facetYmmFilter.value;
                        if(facetYmmFilter.getAttribute("id") === "engineBaseId" && baseVehicleIdSelector){
                            _filterQuery["baseVehicleId"] = baseVehicleIdSelector.value;
                        }
                    }
                }
            }
            return _filterQuery;
        }

        // YMM facets dropdown change events
        setupEventListeners() {
            let __this = this;
            let facetYmmFilters = document.getElementsByClassName("facet__select_ymm");
            let extraFacetFilterTemplate = this.querySelector("#extra-facet-filters");
            if(facetYmmFilters.length > 0){
                facetYmmFilters = Array.prototype.slice.call(facetYmmFilters);
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    if($(window).width()<767){
                        facetYmmFilter.addEventListener("change", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "year";
                            if(_facet === "year"){
                                this.clearAllFilters(["termMake", "termModel"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.fillDropdown('searchMake',[],"Vehicle Make");
                                this.fillDropdown('searchModel',[],"Vehicle Model");
                            }else if(_facet === "make"){
                                //this.clearAllFilters(["termModel", "engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.fillDropdown('searchModel',[],"Vehicle Model");
                            }else if(_facet === "model"){
                                //this.clearAllFilters(["engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                            }
                            let _filterQuery = __this.buildFilterQuery();
                            __this.fetchFacetData(_filterQuery);
                        });
                    }else if($(window).width()>767){
                        
                        $(facetYmmFilter).on("select2:select", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "year";
                            
                            if(_facet === "year"){
                                extraFacetFilterTemplate.innerHTML = "";
                                this.selectedFilter = {};
                                this.clearAllFilters(["termMake", "termModel"]);
                                this.fillDropdown('searchMake',[],"Vehicle Make");
                                this.fillDropdown('searchModel',[],"Vehicle Model");
                            }else if(_facet === "make"){
                                //this.clearAllFilters(["termModel", "engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.clearAllFilters(["termModel"]);
                                this.fillDropdown('searchModel',[],"Vehicle Model");
                            }else if(_facet === "model"){
                                //this.clearAllFilters(["engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                            }
                            let _filterQuery = __this.buildFilterQuery();
                            __this.fetchFacetData(_filterQuery); 
                            
                        });
                    }
                }
            }

            // car filter button 
            let carFilterButton = this.querySelector('[data-car-filter-btn]');
            if(carFilterButton){
                carFilterButton.addEventListener("click", () => {
                    let searchYear = __this.querySelector("#searchYear");
                    let searchMake = __this.querySelector("#searchMake");
                    let searchModel = __this.querySelector("#searchModel");
                    if(searchYear.selectedIndex <=0 || searchMake.selectedIndex <=0 || searchModel.selectedIndex <=0){
                        __this.querySelector('[data-car-filter-error-msg]') ? (
                            __this.querySelector('[data-car-filter-error-msg]').innerText = "Please select all the above fields"
                        ) : undefined;
                        setTimeout(function(){
                            __this.querySelector('[data-car-filter-error-msg]') ? (
                                __this.querySelector('[data-car-filter-error-msg]').innerText = ""
                            ) : undefined;
                        },2000)
                    }
                    this.searchQuery !== "" ? (
                        window.location.href = this.searchQuery
                    ) : undefined;
                    this.isFilterApply = true;
                });
            }

            // home filters
            let facetHomeFilters = document.getElementsByClassName("facet__select_home");
            if(facetHomeFilters.length > 0){
                facetHomeFilters = Array.prototype.slice.call(facetHomeFilters);
                for (let index = 0; index < facetHomeFilters.length; index++) {
                    let facetHomeFilter = facetHomeFilters[index];
                    if($(window).width()<767){
                        facetHomeFilter.addEventListener("change", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "width";
                            let searchWidth = __this.querySelector('#searchWidth') ? __this.querySelector('#searchWidth').value : ""; 
                            let searchHeight = __this.querySelector('#searchHeight') ? __this.querySelector('#searchHeight').value : "";
                            let searchDepth = __this.querySelector('#searchDepth') ? __this.querySelector('#searchDepth').value : "";
                            if(_facet === "width"){
                                searchHeight = "";
                                searchDepth = "";
                                __this.fillHomeDropdown('searchHeight',[],"Filter Length", false);
                                __this.fillHomeDropdown('searchDepth',[],"Filter Depth", false);
                            }else if(_facet === "height"){
                                searchDepth = "";
                                __this.fillHomeDropdown('searchDepth',[],"Filter Depth", false);
                            }
                            __this.fetchHomeData(searchWidth,searchHeight,searchDepth);
                        });
                    }else if($(window).width()>767){
                        $(facetHomeFilter).on("select2:select", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "width";
                            let searchWidth = __this.querySelector('#searchWidth') ? __this.querySelector('#searchWidth').value : ""; 
                            let searchHeight = __this.querySelector('#searchHeight') ? __this.querySelector('#searchHeight').value : "";
                            let searchDepth = __this.querySelector('#searchDepth') ? __this.querySelector('#searchDepth').value : "";
                            if(_facet === "width"){
                                searchHeight = "";
                                searchDepth = "";
                                __this.fillHomeDropdown('searchHeight',[],"Filter Length", false);
                                __this.fillHomeDropdown('searchDepth',[],"Filter Depth", false);
                            }else if(_facet === "height"){
                                searchDepth = "";
                                __this.fillHomeDropdown('searchDepth',[],"Filter Depth", false);
                            }
                            __this.fetchHomeData(searchWidth,searchHeight,searchDepth);
                        });
                    }
                }
            }

             // home filter button 
            let homeFilterButton = this.querySelector('[data-home-filter-btn]');
            if(homeFilterButton){
                homeFilterButton.addEventListener("click", () => {
                    let searchHeight = __this.querySelector("#searchHeight");
                    let searchWidth = __this.querySelector("#searchWidth");
                    let searchDepth = __this.querySelector("#searchDepth");
                    if(searchHeight.selectedIndex <=0 || searchWidth.selectedIndex <=0 || searchDepth.selectedIndex <=0){
                        __this.querySelector('[data-home-filter-error-msg]') ? (
                            __this.querySelector('[data-home-filter-error-msg]').innerText = "Please select all the above fields"
                        ) : undefined;
                        setTimeout(function(){
                            __this.querySelector('[data-home-filter-error-msg]') ? (
                                __this.querySelector('[data-home-filter-error-msg]').innerText = ""
                            ) : undefined;
                        },2000)
                    } 
                    this.homeSearchQuery !== "" ? (
                        window.location.href = `${this.homeSearchQuery}#hometab2`
                    ) : undefined;
                    this.isHomeFilterApply = true;
                });
            }

        } 

        // use to capitalize the word
        _capitalize(word) {
            return word
            .toLowerCase()
            .replace(/\w/, firstLetter => firstLetter.toUpperCase());
        }

        createDropdown(id, dropdownVal){
            let __this = this;
            let _select = document.createElement('select');
            let extraFacetFilterTemplate = this.querySelector("#extra-facet-filters");
            _select.setAttribute('id', id === 'engine' ? FACETS_ATTRIBUTES[id] : id);
            _select.setAttribute('data-facet',id);
            _select.setAttribute('name', `search${id === 'engine' ? this._capitalize(id) : FACETS_ATTRIBUTES[id]}`);
            _select.setAttribute('placeholder', id === 'engine' ? this._capitalize(id) : FACETS_ATTRIBUTES[id]);
            _select.setAttribute('class', "facet__select facet__select_ymm area autocompInputs form-control advanceformselect hide");
            extraFacetFilterTemplate && extraFacetFilterTemplate.append(_select);
            if(dropdownVal) return;
            
            let excludeFacet = ["engineBaseId","AspirationID","RegionID"];
            if($(window).width()>767 && !excludeFacet.includes(FACETS_ATTRIBUTES[id])){
                $(_select).select2({
                    selectOnClose: true,
                    matcher:(params, data) => {
                        return __this._matcher(params, data);
                    },
                    dropdownPosition: 'below'
                });
            } 
            if($(window).width()<767){
                _select.addEventListener("change", (e) => {
                    let _filterQuery = __this.buildFilterQuery();
                    __this.fetchFacetData(_filterQuery);
                });
            }else if($(window).width()>767){
                $(_select).on("select2:select", (e) => {
                    let _filterQuery = __this.buildFilterQuery();
                    __this.fetchFacetData(_filterQuery); 
                    
                });
            } 
        }


        // fill dropdown for the given dropdown id
        fillDropdown(dropdownId, options, placeholder, isResponseHasPartNumber = false, isNextDropdownOpen = true, dropdownVal) {
            let __this = this;
            let facetDropdown = this.querySelector(`#${dropdownId}`); 
            if(facetDropdown){
                facetDropdown.options.length = 0;
                let optFragment = new DocumentFragment();
                let placeholderOpt = document.createElement('option');
                    placeholderOpt.innerText = placeholder
                    placeholderOpt.value = "",
                    placeholderOpt.className = "disabled";
                    placeholderOpt.disabled = true;
                    placeholderOpt.selected = true;
                optFragment.appendChild(placeholderOpt);
                if(options.length > 0){
                    for (let index = 0; index < options.length; index++) {
                        let option = options[index];
                        let opt = document.createElement('option');
                        opt.innerText = option.label
                        opt.value = option.value;
                        if(dropdownVal) opt.selected = 'selected';
                        optFragment.appendChild(opt);
                    }
                }
                facetDropdown.append(optFragment);
                if(dropdownVal) {
                    facetDropdown.value = dropdownVal;
                    return;
                }
                if(!isResponseHasPartNumber){
                    facetDropdown.classList.remove("hide");
                    if($(window).width() > 767){
                        $(facetDropdown).select2({
                            selectOnClose: true,
                            matcher:(params, data) => {
                                return __this._matcher(params, data);
                            },
                            dropdownPosition: 'below'
                        });
                    }
                }
                if(dropdownId !== 'termYear' &&
                    dropdownId !== 'termMake' &&
                    dropdownId !== 'termModel' &&
                    __this.hasForceReload === true
                ){
                    isNextDropdownOpen = true;
                }
                if(dropdownId !== "termYear" && options.length > 0 && isNextDropdownOpen == true && $(`#${dropdownId}`).attr("data-select2-id") && $(window).width() > 767){
                    $(`#${dropdownId}`).select2("open");
                }
            }
        }

        // build options for the dropdowns
        buildOptions(optData) {
            let optionsData = [];
            if(optData.length > 0){
                for (let index = 0; index < optData.length; index++) {
                    let opt = optData[index];
                    if(Object.keys(opt).length > 1){
                        let _tmpObj = {};
                        Object.keys(opt).map((key) => {
                            key === "label" ? _tmpObj.label = opt[key] : _tmpObj.value = opt[key];
                        });
                        optionsData.push(_tmpObj);
                    }else{
                        optionsData.push({
                            label: opt.label,
                            value:opt.label
                        });   
                    }
                    
                }
            }
            return optionsData;
        }

        // fetch facet data for the given year, make, model, engine, aspiration, region and engine type also check for automatic open next dropdown
        async fetchFacetData(facetFilterAttributes = {}, isNextDropdownOpen = true, stopRedirect = false){
            let __this = this;
            this.facetWaitSpinner(true);
            this.searchQuery = "";
           
            let formData = new FormData();
            let _subQuery = "";
            (Object.keys(facetFilterAttributes).length === 0) ? (
                formData.append("termdummy", "year")
            ) : undefined;


            Object.keys(facetFilterAttributes).forEach((key) => {
                facetFilterAttributes[key] && (
                    formData.append(key, facetFilterAttributes[key]),
                    _subQuery+=`${key}:${facetFilterAttributes[key]}|`
                );
                
            });

            let apiRes = await fetch(API_FACET_BASE_URL,{
                method:"POST",
                mode:"cors",
                body:formData
            }).then(async response => {
                return await response.json();
            }).then(json => {
                return json;
            });

            
            let isResponseHasPartNumber = apiRes.response.filter((item) => {
                return item.partNumber ? true : false;
            }).length > 0;

            let _optData = apiRes.response || [];

            // added fix for NRC products
            if(_optData.length === 1) {
                if(_optData[0].partNumber == 'NRC' || _optData[0].partNumber == 'NR' ) {
                    // if(!stopRedirect) window.location.href = `/pages/not-required`;
                    window.location.href = `/pages/not-required`;
                    this.facetWaitSpinner(false);
                    return stopRedirect ? apiRes : undefined;
                }
            }
            // added fix for NA products end
            if(_optData.length === 0) {
                localStorage.setItem("selectedModel",facetFilterAttributes?.termModel);
                localStorage.setItem("selectedMake",facetFilterAttributes?.termMake);
                localStorage.setItem("selectedYear",facetFilterAttributes?.termYear);
                if(!stopRedirect) window.location.href = `/pages/not-available-in-pureflow`;
                this.facetWaitSpinner(false);
                return stopRedirect ? apiRes : undefined;
            };

            _optData = this.buildOptions(_optData);
            
             // add baseVehicleId into hidden input field
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");    
            apiRes.baseVehicleId && baseVehicleIdSelector && apiRes?.baseVehicleId && (
                baseVehicleIdSelector.value = apiRes.baseVehicleId || "N/A"
            );
            
            if(Object.keys(facetFilterAttributes).length === 0){
                this.fillDropdown("termYear",_optData, "Vehicle Year", isResponseHasPartNumber, isNextDropdownOpen);
            }else if(apiRes?.name !== "" && !isResponseHasPartNumber){
                if(!YMM_ATTRIBUTES[apiRes?.name]){
                    const facetsEntries = Object.entries(FACETS_ATTRIBUTES).filter(facet => {
                        return apiRes[facet[1]]
                    });
                    if(facetsEntries.length){
                        facetsEntries.forEach(facet => {
                            const tempId = facet[0];
                            const key = facet[1];
                            const hasDropdown = document.querySelector(`#${key}`);
                            if(!key || hasDropdown || !apiRes[key]) return;
                            let tempVal = apiRes[key];
                            tempVal = tempVal.replaceAll('\'','');
                            this.createDropdown(tempId, tempVal);
                            this.fillDropdown(FACETS_ATTRIBUTES[tempId],[{label: tempId, value: tempVal}],`Vehicle ${this._capitalize(tempId)}`, isResponseHasPartNumber, isNextDropdownOpen, tempVal);
                        });
                    }

                    this.createDropdown(apiRes?.name);
                }
                // !YMM_ATTRIBUTES[apiRes?.name] && this.createDropdown(apiRes?.name, apiRes?.engineBaseId);
                
                if(apiRes?.name === "engine" && !apiRes?.engineBaseId){
                    this.fillDropdown(FACETS_ATTRIBUTES[apiRes?.name],_optData,`Vehicle ${this._capitalize(apiRes?.name)}`, isResponseHasPartNumber, isNextDropdownOpen);
                }else if(this.querySelector(`#${YMM_ATTRIBUTES[apiRes?.name] || apiRes?.name}`)){
                    this.fillDropdown(YMM_ATTRIBUTES[apiRes?.name] || apiRes?.name,_optData, YMM_ATTRIBUTES[apiRes?.name] ? `Vehicle ${this._capitalize(apiRes?.name)}` : this._capitalize(FACETS_ATTRIBUTES[apiRes?.name]), isResponseHasPartNumber, isNextDropdownOpen);
                }
            }
            if(isResponseHasPartNumber && apiRes?.response?.length > 0){
                let _products = apiRes?.response?.map((opt) => {
                    return opt.partNumber;
                });
                if(_products.length === 0) { 
                    return;
                }
                
                let formDataProduct = new FormData();
                formDataProduct.append("termYear", facetFilterAttributes?.termYear || "");
                formDataProduct.append("termMake", facetFilterAttributes?.termMake || "");
                formDataProduct.append("termModel", facetFilterAttributes?.termModel || "");
                formDataProduct.append("partNumber", _products.join(","));
                let productHandles = await fetch(API_PRODUCT_BASE_URL,{
                    method:"POST",
                    mode:"cors",
                    body:formDataProduct
                }).then(async response => {
                    return response.json();
                }).then(json => {
                    return json;
                });
                
                if(productHandles.response.length === 0){
                    localStorage.setItem("selectedModel",facetFilterAttributes?.termModel);
                    localStorage.setItem("selectedMake",facetFilterAttributes?.termMake);
                    localStorage.setItem("selectedYear",facetFilterAttributes?.termYear);
                    if(!stopRedirect) window.location.href = `/pages/not-available-in-pureflow`; //added for 11jun fix
                    return stopRedirect ? apiRes : undefined;
                }
                let _handles = productHandles.response.map((product) => {
                    return product.handle;
                });
                this.isFilterApply = true;
                this.hasForceReload === true ? (
                    isNextDropdownOpen = true
                ) : (
                    isNextDropdownOpen = isNextDropdownOpen
                );
                this.searchQuery = `/search?type=product&q=(handle:${_handles.join(" OR handle:")})&filter=carair@advance-filter=${_subQuery.slice(0,-1)}`;
                
                if(isNextDropdownOpen === true){
                    window.location.href = this.searchQuery;
                }
            }
            setTimeout(() => {
                __this.facetWaitSpinner(false);
            },200);
            if(isNextDropdownOpen === false){
                return {"success":true}
            }
        }
        
        // fetch home filter data
        async fetchHomeData(filterWidth = "", filterLength = "", filterDepth = "", isNextDropdownOpen = true){

            let _homeFilterTags = this.homeFilterTags;

            let _apiRes = [];
            let data = {};
            data.filterWidth = filterWidth;
            data.filterLength = filterLength;
            data.filterDepth = filterDepth;

            for (let index = 0; index < _homeFilterTags.length; index++) {
                let _homeFilterTag = _homeFilterTags[index];
                let _val = "";
                if(filterWidth === "" && filterLength === "" && filterDepth === ""){
                    _val = _homeFilterTag.split("x")[0];
                }else if(filterWidth !== "" && filterLength === "" && filterDepth === ""){
                    _val = Number(filterWidth) === Number(_homeFilterTag.split("x")[0]) && _homeFilterTag.split("x")[1];
                }else if(filterWidth !== "" && filterLength !== "" && filterDepth === ""){
                    let _key = `${filterWidth}x${filterLength}x${_homeFilterTag.split("x")[2]}`
                    _val = _key === _homeFilterTag && _homeFilterTag.split("x")[2];
                }
                !_apiRes.includes(Number(_val)) && Number(_val) > 0 && _apiRes.push(Number(_val));
            }
            _apiRes.sort();

            // fill width dropdown
            (filterWidth === "" && filterLength === "" && filterDepth === "") ? (
                this.fillHomeDropdown("searchWidth",_apiRes, "Filter Width", isNextDropdownOpen)
            ) : undefined;
            
            // fill height dropdown
            (filterWidth !== "" && filterLength === "" && filterDepth === "") ? (
                this.fillHomeDropdown("searchHeight",_apiRes, "Filter Length", isNextDropdownOpen)
            ) : undefined;

            // fill depth dropdown
            (filterWidth !== "" && filterLength !== "" && filterDepth === "") ? (
                this.fillHomeDropdown("searchDepth",_apiRes, "Filter Depth", isNextDropdownOpen)
            ) : undefined;

            // build search query and redirect to search result page for home filter
            (filterWidth !== "" && filterLength !== "" && filterDepth !== "") ? ( 
                this.isHomeFilterApply = true,
                this.homeSearchQuery = `/search?q=hvac,Width_${filterWidth},Height_${filterLength},Depth_${filterDepth}`
            ): undefined;
            if(this.homeSearchQuery !== "" && isNextDropdownOpen === true){
                window.location.href = `${this.homeSearchQuery}#hometab2`;
            }
        }

        // fill home filter dropdown
        fillHomeDropdown(dropdownId, options, placeholder, isNextDropdownOpen = false){
            let facetDropdown = this.querySelector(`#${dropdownId}`); 
            if(facetDropdown){
                facetDropdown.options.length = 0;
                let optFragment = new DocumentFragment();
                let placeholderOpt = document.createElement('option');
                    placeholderOpt.innerText = placeholder
                    placeholderOpt.value = "",
                    placeholderOpt.className = "disabled";
                    placeholderOpt.disabled = true;
                    placeholderOpt.selected = true;
                optFragment.appendChild(placeholderOpt);
                if(options.length > 0){
                    for (let index = 0; index < options.length; index++) {
                        let option = options[index];
                        let opt = document.createElement('option');
                        opt.innerText = option
                        opt.value = option;
                        optFragment.appendChild(opt);
                    }
                }
                facetDropdown.append(optFragment);
                if(dropdownId !== "searchYear" && options.length > 0 && isNextDropdownOpen == true){
                    $(`#${dropdownId}`).attr("data-select2-id") && $(`#${dropdownId}`).select2("open");
                }
            }
        }
    }

    // register custom element
    customElements.define("pur-facet-filter", PurFacetFilter);
}